<template>
  <q-layout
    view="hHh lpr fFf"
    bordered
    class="shadow-2 rounded-borders vonix-phone-classes"
  >
    <q-page-container>
      <q-page
        class="vonix-font bg-white"
        :style-fn="myTweak"
      >
        <router-view />
        <InnerOffer />
      </q-page>
    </q-page-container>

    <audio
      id="remoteAudio"
      style="display: none"
    />
  </q-layout>
</template>

<script>
import InnerOffer from './InnerOffer'
const systemPreferences = window.systemPreferences

export default {
  components: {
    InnerOffer
  },

  mounted () {
    this.$store.dispatch('connectionModule/startListeners', null, { root: true })
    this.askPermissions()
  },

  methods: {
    myTweak (offset) {
      return {
        width: '100vw',
        height: `calc(100vh - ${offset}px)`,
        maxHeight: `calc(100vh - ${offset}px)`
      }
    },

    async askPermissions () {
      if (systemPreferences) await systemPreferences.askForMediaAccess('microphone')
      Notification.requestPermission()
    }
  }
}
</script>

<style lang="sass">
.vonix-font
  font-family: Roboto
  font-style: normal
  display: flex
  color: #263238

body::-webkit-scrollbar
  width: 0px

</style>
